/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { LoadListIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const loadListIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const loadListIndexFetchLoadListIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const loadListIndexFetchLoadListIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const loadListIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const loadListIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const loadListIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const loadListIndexWorkspaceLoading = (state, { boolean }) => ({
  ...state,
  workspaceIsLoading: boolean
});

export const loadListIndexResetLoadListSync01Success = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [LoadListIndexTypes.LOAD_LIST_INDEX_RESET_TIMESTAMP]: loadListIndexResetTimestamp,
  [LoadListIndexTypes.LOAD_LIST_INDEX_FETCH_LOAD_LIST_INDEX_LOADING]: loadListIndexFetchLoadListIndexLoading,
  [LoadListIndexTypes.LOAD_LIST_INDEX_FETCH_LOAD_LIST_INDEX_SUCCESS]: loadListIndexFetchLoadListIndexSuccess,
  [LoadListIndexTypes.LOAD_LIST_INDEX_ADD_SELECTED_DOCUMENTS]: loadListIndexAddSelectedDocuments,
  [LoadListIndexTypes.LOAD_LIST_INDEX_REMOVE_SELECTED_DOCUMENTS]: loadListIndexRemoveSelectedDocuments,
  [LoadListIndexTypes.LOAD_LIST_INDEX_SET_WORKSPACE_VISIBLE]: loadListIndexSetWorkspaceVisible,
  [LoadListIndexTypes.LOAD_LIST_INDEX_WORKSPACE_LOADING]: loadListIndexWorkspaceLoading,
  [LoadListIndexTypes.LOAD_LIST_INDEX_RESET_LOAD_LIST_SYNC01_SUCCESS]: loadListIndexResetLoadListSync01Success
});
